import { Urls } from "../constants/UrlConstants";
import React, { Fragment } from "react";
import layoutStyle from "../assets/css/modules/shared/layout.css";

const ChooseYourPlan = {
  Title: {
    Any: "Choose your plan",
    HOL: "Choose your policy"
  },
  ButtonText: {
    Any: " Go to my plan",
    HOL: "Go to my policy"
  },
  PolicyPanelStatus: {
    HOL: "Moved to AXA Health",
    Any: ""
  },
  MovedToAxaHealthMessage: (
    <Fragment>
      Please go to your new AXA Health{" "}
      <a
        className={`hol-link ${layoutStyle.anchorDecorationUnderline}`}
        href={Urls.MOL.Prod}
        rel="noopener noreferrer"
        target="_blank"
      >
        member site
      </a>{" "}
      to access this plan information.
    </Fragment>
  )
};

export default ChooseYourPlan;
